import { z } from "zod"

export const passwordZ = z
  .string({ message: "パスワードを入力してください" })
  .min(8, "8文字以上で入力してください")
  .regex(/^[0-9A-Za-z]+$/, "半角英数字のみで入力してください")

export const signInEmailRequestSchema = z.object({
  email: z
    .string()
    .min(1, "メールアドレスを入力してください")
    .email("有効なメールアドレスを入力してください"),
  password: passwordZ,
})

export const forgetPasswordRequestSchema = z.object({
  email: z
    .string()
    .min(1, "メールアドレスを入力してください")
    .email("有効なメールアドレスを入力してください"),
})

export const resetPasswordRequestSchema = z.object({
  newPassword: passwordZ,
  token: z.string().nullable(),
})

export type SignInEmailRequest = z.infer<typeof signInEmailRequestSchema>
export type ForgetPasswordRequest = z.infer<typeof forgetPasswordRequestSchema>
export type ResetPasswordRequest = z.infer<typeof resetPasswordRequestSchema>
